<template>
  <div class="login-layout">
    <header class="login-layout__header">
      <auth-header-block>
        <router-link-to
          default_button
          :route_name="route_names.login">
          {{ $t('auth.have_account') }}
        </router-link-to>
      </auth-header-block>
    </header>
    <div class="login-layout__main">
      <div class="login-layout__main-inner">
        <h4>{{ $t('auth.forgot_your_password') }}</h4>
        <gray-text class="mt-10">
          {{ $t('auth.enter_your_email_to_reset_password') }}
        </gray-text>
        <hr class="my-30"/>
        <ValidationObserver v-slot="{ invalid, passes }" ref="form">
        <default-form class="d-flex flex-column"
              ref="form"
                      @submit.prevent="passes(submit)">

          <div class="row">
            <div class="col-12">
              <default-input
                name="email"
                type="test"
                placeholder="your@mail.com"
                :label="$t('inputs.email')"
                required
                v-model="email"
              />
            </div>
            <template v-if="get_hash">
              <div class="col-sm-6 col-12">
                <default-input
                  class="mt-10"
                  :label="$t('inputs.password')"
                  type="password"
                  placeholder="Minimum 8 characters"
                  required
                  v-model="reset.password"
                />
              </div>
              <div class="col-sm-6 col-12">
                <default-input
                  class="mt-10"
                  :label="$t('user.confirm_password')"
                  type="password"
                  name="password_confirm"
                  placeholder="Minimum 8 characters"
                  required
                  v-model="reset.password_confirmation"
                />
              </div>
            </template>
          </div>

          <info-block
            v-if="response_message"
            :success="!response_error"
            :error="response_error"
            class="mt-20">
            {{ response_message }}
          </info-block>
          <default-button
            class="mt-20">
            {{ $t('inputs.reset') }}
          </default-button>
        </default-form>
        </ValidationObserver>
      </div>
    </div>
    <loader v-if="loading"/>
  </div>
</template>

<script>

import GrayText from "../../small_components/GrayText.vue";
import DefaultButton from "../../small_components/DefaultButton.vue";
import InfoBlock from "../../small_components/InfoBlock.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import {axiosAuth} from "../../../helpers/axios_requests";
import Loader from "../../small_components/Loader.vue";
import {mapActions, mapGetters} from "vuex";
import AuthHeaderBlock from "../../parts/AuthHeaderBlock.vue";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import routes_mixin from "../../../mixins/routes_mixin";
import DefaultForm from "../../small_components/form-parts/DefaultForm.vue";
import {GO_TO_LOGIN} from "../../../router";
import {FORMAT_ERROR_MESSAGE} from "../../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../../store/modules/notifiocation";
import {ValidationObserver} from "vee-validate";

export default {
  name: 'ForgotPasswordLayout',
  mixins: [routes_mixin],
  components: {
    DefaultForm,
    RouterLinkTo,
    AuthHeaderBlock,
    Loader,
    DefaultInput,
    InfoBlock,
    DefaultButton,
    GrayText,
    ValidationObserver
  },
  computed: {
    ...mapGetters([
      'getUserMailVerified'
    ]),
    get_hash () {
      return this.$route.params?.hash
    }
  },
  data() {
    return {
      show_error: false,
      email: '',
      response_error: false,
      response_message: '',
      loading: false,
      reset: {
        password: '',
        password_confirmation: ''
      }
    }
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    submit() {
      if (this.get_hash) {
        this.submitFormReset()
      } else {
        this.submitForm()
      }
    },
    submitForm() {
      this.loading = true
      this.response_message = ''
      this.response_error = false
      axiosAuth.forgotPassword({
        email: this.email,
      }).then(({data}) => {
        if (data.errors) {
          this.$refs.form.setErrors(data.errors);
          let message = FORMAT_ERROR_MESSAGE(data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.response_message = data.message
      }).catch(e => {
        this.response_error = true
        this.response_error = e.response?.data.error || e.response?.data.message
      }).finally(() => {
        this.loading = false
      })
    },
    submitFormReset() {
      this.loading = true
      this.response_message = ''
      this.response_error = false

      axiosAuth.forgotPasswordReset({
        ...this.reset,
        ...{email: this.email},
        ...{token: this.get_hash},
      }).then(({data}) => {
        if (data.errors) {
          this.$refs.form.setErrors(data.errors);
          let message = FORMAT_ERROR_MESSAGE(data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.response_message = data.message

        setTimeout(() => {
          GO_TO_LOGIN()
        }, 1500)
      }).catch(e => {
        console.log(e);
        this.response_error = true
        this.response_message = e.response?.data.error || e.response?.data.message
        this.loading = false
      })
    }
  }
}
</script>
